<div
  class="adviory-message-block white-border down-shadow"
  data-cy="flightAdvisoryBanner"
>
  <div class="col-12 row heading-wrapper mpt-2 no-gutters">
    <div class="col-md-auto col-sm-12">
      <div class="headingOne" id="headingOne">
        <h3 class="title">
          <span class="iconMix" data-font-icon="&#xe98f;"></span>
          {{ config.advisoryLabel }}
        </h3>
      </div>
    </div>

    <div class="col-md col-sm-12">
      <div [innerHTML]="config.advisoryMessage" class="advisory-message"></div>
    </div>
  </div>
</div>
